import Model from 'core/model/Model';

class UserQuestionModel extends Model {
  get isSelected() {
    return false;
  }
}

export default UserQuestionModel;
